export const INSURANCE_FLOW_TYPE = {
  PAPERWORK: 'PAPERWORK',
  PROFILE: 'PROFILE',
  GET_CARE_FLOW: 'GET_CARE_FLOW',
  TO_DO: 'TO_DO',
};

export const SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES = [
  INSURANCE_FLOW_TYPE.TO_DO,
  INSURANCE_FLOW_TYPE.PROFILE,
];



// WEBPACK FOOTER //
// ./src/constants/insurance-flow-type.js